import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Meil on ruumi kõikidele su soovidele!

  <span style="color:#85c1dc;">**FI:**</span>
  Meillä on tilaa kaikille toiveillesi!

  <span style="color:#85c1dc;">**RU:**</span>
  У нас есть место для всех Ваших пожеланий!
*/
/* @__NO_SIDE_EFFECTS__ */
const m1335 = msg(
  mf`Meil on ruumi kõikidele su soovidele!`,
  mf`Meillä on tilaa kaikille toiveillesi!`,
  mf`У нас есть место для всех Ваших пожеланий!`,
)

export { m1335 as 'w.wishlist.empty_wishlist_title' }